module.exports = __webpack_public_path__ + "static/media/vent-direccio-5.ca700043.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vent-direccio-5.svg
// module id = 203
// module chunks = 0